<template>
  <!-- 成员树 -->
  <el-tree
    ref="memberTree"
    :props="props"
    :data="data"
    node-key="value"
    v-on="$listeners"
    :filter-node-method="filterNode"
    v-bind="attrs"
    v-loading="loading"
  >
  </el-tree>
</template>

<script>
import { isEqual, cloneDeep } from 'lodash-es'
import store from '@/store'
export default {
  name: 'member-tree',
  props: {
    // 是否开启单选
    single: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      attrs: {},
      data: [],
      props: {
        label: 'text',
        children: 'children',
        isLeaf: 'leaf'
      },
      memberList: [],
      timer: null
    }
  },
  mounted() {
    store.dispatch('queryDepartUserTree', {
      qiYeGuid: store.state.userInfo.corpId
    }).then((res) => {
      this.loading = false
      this.data = res
      this.timer = setInterval(() => {
        if (this.$refs.memberTree) {
          this.$refs.memberTree.filter()
          clearInterval(this.timer)
        }
      }, 300)
    }).catch(() => {
      this.loading = false
    })
  },
  watch: {
    $attrs: {
      handler(newVal, value) {
        if (!isEqual(newVal, value)) {
          this.attrs = cloneDeep(newVal)
        }
      },
      immediate: true
    }
  },
  methods: {
    getInstance() {
      return this.$refs.memberTree
    },
    filterNode(value, data, node) {
      // 不展示成员
      if (node.data.type === 1) {
        this.memberList.push(node.data)
      }
      return node.data.type !== 1
    }
  }
}
</script>

<style></style>
